import { getDateFirstDay4 } from '../utils/getDate.js';

const OwnActivitiesCard = ({ activityData }) => {
    return (
        <div className={`flex flex-col md:flex-row gap-8 md:gap-2 lg:gap-4 justify-between items-center md:items-center w-full bg-white py-4 md:px-2 px-4 rounded-xl text-sm`}>
            <div className='flex flex-col md:flex-row gap-2 items-center'>
                <div className="w-12 h-12"><img src={activityData.coverImageUrl ? activityData.coverImageUrl.resizedUrl : ''} alt={activityData.title || ''} className="flex-1 rounded object-cover w-full h-full" /></div>
                <div className="w-[240px] flex flex-col text-center md:text-start">
                    <div className='font-bold'>{activityData.title}</div>
                    {activityData && <div>{`${activityData.price.length > 0 ? `Da ${activityData.price[0].value} CHF` : 'Gratuita'}`}</div>}
                </div>
            </div>

            <div className='flex gap-2'>
                <div className="flex flex-col lg:flex-row gap-2 border rounded p-2">
                    <div>Creata il:</div>
                    <div>{getDateFirstDay4(activityData.createdAt)}</div>
                </div>
                <div className="flex flex-col lg:flex-row gap-2 border rounded p-2">
                    <div>Ultima modifica:</div>
                    <div>{getDateFirstDay4(activityData.updatedAt)}</div>
                </div>
            </div>

        </div>
    )
}

export default OwnActivitiesCard;